import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { User } from 'src/interfaces/iuser';
import UploadCsv from './Components/UploadCsv';
import RegionUpdateDashboard from './Components/RegionUpdateDashboard';

const CsvToMapEditorTool = ({ user, getUserInfo }: { user: User; getUserInfo: any }) => {
  const [pageLoading, isPageLoading] = useState(true);
  const [uploadedCsv, setUploadedCsv] = useState<any>(null);
  const [updatedCsv, setUpdatedCsv] = useState<{ [key: string]: string }>({});

  const marketSuggessionCacheStorage = {};

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    if (user.email !== 'Trial') {
      isPageLoading(false);
    }
  }, [user]);

  useEffect(()=> {
    console.log("==>> ", updatedCsv);
  }, [updatedCsv]);

  if (pageLoading) {
    return (
      <Grid
        xs={12}
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', minHeight: '98vh' }}
      >
        <CircularProgress />
      </Grid>
    );
  }

  if (user.role !== 'admin') {
    return (
      <Grid
        xs={12}
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', minHeight: '98vh' }}
      >
        <Typography variant="h4">You are not authorized to view this page</Typography>
      </Grid>
    );
  }

  if (uploadedCsv) {
    return (
      <RegionUpdateDashboard
        uploadedCsv={uploadedCsv}
        updatedCsv={updatedCsv}
        setUpdatedCsv={setUpdatedCsv}
        marketSuggessionCacheStorage={marketSuggessionCacheStorage}
      />
    );
  }

  return (
    <>
      <UploadCsv uploadedCsv={uploadedCsv} setUploadedCsv={setUploadedCsv} />
    </>
  );
};

export default CsvToMapEditorTool;
